import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, unref as _unref, isRef as _isRef, toDisplayString as _toDisplayString, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive } from "vue"
import _imports_0 from '../src/assets/logo.png'


const _hoisted_1 = { style: {"display":"flex","justify-content":"space-between","line-height":"60px"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"26px","height":"26px","vertical-align":"middle","padding-right":"10px"},
    src: _imports_0
  }),
  /*#__PURE__*/_createTextVNode("openLayersMap")
], -1)
const _hoisted_3 = { class: "right-side" }
const _hoisted_4 = { style: {"cursor":"pointer"} }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { style: {"padding-bottom":"10px"} }, "主题颜色：", -1)
const _hoisted_6 = { style: {"display":"flex"} }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { style: {"background-color":"#fff","height":"45px","line-height":"42px","width":"100%","overflow-x":"overlay","overflow-y":"hidden","white-space":"nowrap"} }
const _hoisted_9 = { style: {"height":"calc(100vh - 130px)","padding":"12px","overflow":"overlay"} }

import '@/assets/style.scss'
import { ref } from "vue";
import Nav from "./components/Nav.vue";
import router from "./router";
import { useStore } from 'vuex'

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore()
let dynamicTags = ref([{
  "menuID": "00",
  "title": "首页",
  "path": "/"
},])
const colorList = ['#6177fc', '#409EFF','#0b75cf', '#041938','#42a021','#e17a14','red']
const color1 = localStorage.getItem('themeColors')||colorList[0]
const storageData = localStorage.getItem('navActive')
if (storageData != null) {
  let data = JSON.parse(storageData)
  store.commit('changeNavActive', data.menuID)
  var flag = dynamicTags.value.find((cur: { title: any; }) => cur.title == data.title)		//查找一下传入的数值和数组中的数值是否相同
  if (!flag) {
    dynamicTags.value.push(data)		// 如果没有就直接push
  }
}
const handleClose = (tag: { menuID: string; }) => {
  dynamicTags.value.splice(dynamicTags.value.indexOf(tag), 1)
  if (tag.menuID == store.state.navActive) {
    router.push(dynamicTags.value[dynamicTags.value.length - 1].path);
    store.commit('changeNavActive', dynamicTags.value[dynamicTags.value.length - 1].menuID)
  }

}

const handleClick = (item: {
  menuID: any; path: string;
}, index: number) => {
  router.push(item.path);
  store.commit('changeNavActive', item.menuID)
  localStorage.setItem('navActive', JSON.stringify(item))
}
let isCollapse2 = ref(false)
let changesCollapse = (val: boolean) => {
  isCollapse2.value = val
}
let changesJump = (tag: { title: string; }) => {

  var flag = dynamicTags.value.find(cur => cur.title == tag.title)		//查找一下传入的数值和数组中的数值是否相同
  if (!flag) {
    dynamicTags.value.push(tag)		// 如果没有就直接push
  }
}
const themeColorsHandle = (color:string)=>{
  console.log("函数体",color)
  localStorage.setItem('themeColors',color)
  const el = document.documentElement
  getComputedStyle(el).getPropertyValue(`--el-color-primary`)
  el.style.setProperty('--el-color-primary', localStorage.getItem('themeColors'))
}
const intColor = color1
themeColorsHandle(intColor)

const changeColor = (color:string)=>{
  console.log("函数调用",color)
  themeColorsHandle(color)
}


return (_ctx: any,_cache: any) => {
  const _component_Tools = _resolveComponent("Tools")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_color_picker = _resolveComponent("el-color-picker")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_popover, {
                ref: "popover",
                width: 300,
                trigger: "click"
              }, {
                reference: _withCtx(() => [
                  _createElementVNode("span", _hoisted_4, [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Tools)
                      ]),
                      _: 1
                    }),
                    _createTextVNode("设置")
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _hoisted_5,
                    _createElementVNode("div", _hoisted_6, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(colorList, (item) => {
                        return _createElementVNode("div", {
                          onClick: ($event: any) => (changeColor(item)),
                          key: item,
                          style: _normalizeStyle([{ background: item }, {"width":"20px","height":"20px","border-radius":"2px","margin-right":"10px"}])
                        }, null, 12, _hoisted_7)
                      }), 64)),
                      _createVNode(_component_el_color_picker, {
                        modelValue: _unref(color1),
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(color1) ? (color1).value = $event : null)),
                        onChange: _cache[1] || (_cache[1] = ($event: any) => (changeColor(_unref(color1))))
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _: 1
              }, 512)
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_aside, {
            width: _unref(isCollapse2) ? '64px' : '270px'
          }, {
            default: _withCtx(() => [
              _createVNode(Nav, {
                onChangesCollapse: _unref(changesCollapse),
                onChangesJump: _unref(changesJump)
              }, null, 8, ["onChangesCollapse", "onChangesJump"])
            ]),
            _: 1
          }, 8, ["width"]),
          _createVNode(_component_el_main, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dynamicTags), (tag, index) => {
                  return (_openBlock(), _createBlock(_component_el_tag, {
                    key: tag.title,
                    class: "mx-1",
                    type: tag.menuID == _unref(store).state.navActive ? '' : 'info',
                    effect: tag.menuID == _unref(store).state.navActive ? 'dark' : 'plain',
                    size: "large",
                    closable: index == 0 ? false : true,
                    "disable-transitions": false,
                    onClose: ($event: any) => (handleClose(tag)),
                    onClick: ($event: any) => (handleClick(tag, index))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(tag.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["type", "effect", "closable", "onClose", "onClick"]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_router_view, null, {
                  default: _withCtx(({ Component }) => [
                    (_openBlock(), _createBlock(_KeepAlive, { exclude: "HomeView" }, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                    ], 1024))
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})